import type { TabulusOptions } from '@tabulus/types';

const defaultOptions: TabulusOptions = {
  align: 'center',
};

export { defaultOptions };
